import { render, staticRenderFns } from "./RankingSection.vue?vue&type=template&id=5b40de82"
import script from "./RankingSection.vue?vue&type=script&lang=js"
export * from "./RankingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports